import { BaseRepository } from '@/base/base-repository';
import { CAMPAIGN_CFG } from '@/configs/campaign-config';

export interface CampaignTicketSummary {
	totalWagered: number;
	lastUpdated?: string;
}

export interface CampaignStreakLeaderSummary {
	address: string | null;
	resolvedName: string | null;
	bestStreak: number;
	lastUpdated?: string;
}

class CampaignRepository extends BaseRepository {
	async getTicketSummary({
		address,
		start,
		end,
		path = CAMPAIGN_CFG.ticketing.apiPath,
	}: {
		address: string;
		start: string;
		end: string;
		path?: string;
	}): Promise<CampaignTicketSummary> {
		try {
			const response = await this.httpClient({
				method: 'get',
				url: path,
				params: {
					address,
					start,
					end,
				},
			});
			const totalWageredRaw = response?.totalWagered ?? response?.total_wagered ?? 0;
			const lastUpdatedRaw = response?.lastUpdated ?? response?.last_updated ?? undefined;
			return {
				totalWagered: Number(totalWageredRaw ?? 0),
				lastUpdated: lastUpdatedRaw != null ? String(lastUpdatedRaw) : undefined,
			};
		} catch (error) {
			console.warn('Failed to fetch campaign ticket summary', { path, address, error });
			return { totalWagered: 0 };
		}
	}

	async getStreakLeaderSummary(slug: string): Promise<CampaignStreakLeaderSummary> {
		try {
			const response = await this.httpClient<CampaignStreakLeaderSummary>({
				method: 'get',
				url: `/campaigns/${slug}/streak-leader`,
			});
			return {
				address: response?.address ?? null,
				resolvedName: response?.resolvedName ?? null,
				bestStreak: Number(response?.bestStreak ?? 0),
				lastUpdated: response?.lastUpdated != null ? String(response.lastUpdated) : undefined,
			};
		} catch (error) {
			console.warn('Failed to fetch campaign streak leader', { slug, error });
			return {
				address: null,
				resolvedName: null,
				bestStreak: 0,
			};
		}
	}
}

export const campaignRepository = new CampaignRepository();
